export const ExternalProviderType = {
  Expenses: 0,
  Rio: 1,
  SystmOne: 2,
  Emis: 3,
};
